import component from './GuestsRoomsChildrenPopover';

export default component;
